module.exports = __webpack_public_path__ + "media/images/header__bg-1bf1663637ea7f40ff1e5c805fe9cf41.jpg";